import { parseAsInteger, useQueryState } from "nuqs";

export const useRefundDialogParam = () => {
  return useQueryState("refundPaymentId", parseAsInteger);
};
